class ProductMain extends HTMLElement {
  constructor() {
    super();
    this._selectors = {
      colorSwatches: "[js-color-swatches-wrapper]",
    };
  }

  connectedCallback() {
    this.nostoCarouselLoad();
    const swatchesWrapper = this.querySelector(this._selectors.colorSwatches);
    const relatedColorsGroup = swatchesWrapper.querySelector('.custom-color-selectors').getAttribute('data-group');
    if (swatchesWrapper === null || relatedColorsGroup === null || relatedColorsGroup === "") {
      return;
    } else {
      this._initRelatedColors();
    }
  }

  nostoCarouselLoad(){
    if (window.innerWidth > 768) return;
    const nostoCarousel = this.querySelector('.nosto-carousel');
    nostoCarousel.remove();
  }

  async _initRelatedColors() {
    this.relatedColorsContainer = this.querySelector(
      this._selectors.colorSwatches
    );

    if (this.relatedColorsContainer === null) {
      return;
    }


    const relatedColorsGroup =
      this.relatedColorsContainer.querySelector('.custom-color-selectors').getAttribute('data-group');
    const currentColorHandle =
      this.relatedColorsContainer.querySelector('.custom-color-selectors').getAttribute('data-currenthandle');  
    const targetURL = `/collections/all/${relatedColorsGroup}/?view=json`;
    const relatedColorsJSON = await this._getRelatedColorJSON(targetURL);
    let relatedColorsMarkup = "";

    const swatchesProduct = relatedColorsJSON.filter( product => product.available == true );

    swatchesProduct.forEach((product) => {
      let swatch = "";
      let priority = 99;
      if (product.color_priority != "") {
        priority = product.color_priority;
      }
      if (
        product.handle == currentColorHandle
      ) {
        if (product.meta_swatch?.color_code) {
          swatch = `<a href="${ product.url }" class="active" style="order:${priority};"><span style="background: ${ product.meta_swatch.color_code };"></span></a>`;
        } else if (product.meta_swatch?.linear_gradient) {
          swatch = `<a href="${ product.url }" class="active" style="order:${priority};"><span style="background: ${ product.meta_swatch.linear_gradient };"></span></a>`;
        } else if (product.meta_swatch?.image) {
          swatch = `<a href="${ product.url }" class="active" style="order:${priority};"><span style="background: url(${ product.meta_swatch.image }) ;"></a>`;
        } else {
          swatch = `<a href="${ product.url }" class="active" style="order:${priority};"><span style="background: #000;"></span></a>`;
        }
      } else {
        if (product.meta_swatch?.color_code) {
          swatch = `<a href="${ product.url }" style="order:${priority};"><span style="background: ${ product.meta_swatch.color_code };"></span></a>`;
        } else if (product.meta_swatch?.linear_gradient) {
          swatch = `<a href="${ product.url }" style="order:${priority};"><span style="background: ${ product.meta_swatch.linear_gradient };"></span></a>`;
        } else if (product.meta_swatch?.image) {
          swatch = `<a href="${ product.url }" style="order:${priority};"><span style="background: url(${ product.meta_swatch.image }) ;"></a>`;
        } else {
          swatch = `<a href="${ product.url }" style="order:${priority};"><span style="background: #000;"></span></a>`;
        }
      }

      relatedColorsMarkup = `${relatedColorsMarkup}${swatch}`;
    });

    this.relatedColorsContainer.querySelector(".custom-options").innerHTML = relatedColorsMarkup;
  }

  _getRelatedColorJSON(url) {
    return theme.utils.relatedColorJSON.fetch(url);
  }
}

customElements.define("product-main", ProductMain);
